export default __webpack_public_path__ + "static/media/logo_blanc.aad2b6fe.png";